import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as Forward } from '../../../assets/icons/forward.svg';
import PrimaryButton from '../../../components/buttons/primarybutton/PrimaryButton';
import FeedbackButton from '../../../components/feedbackbutton/FeedbackButton';
import Header from '../../../components/header/Header';
import Hints from '../../../components/hints/Hints';
import H2 from '../../../components/text/H2';
import { tag } from '../../../services/ATInternetService';
import { hasUserAction } from '../../../stored/UserActions';

const Start = ({ onNextSlideRequested }) => {
	const isBrowserSupported =
		!navigator.userAgent.toLowerCase().includes('samsung') &&
		!navigator.userAgent.toLowerCase().includes('opera') &&
		!navigator.userAgent.includes('OPR');

	return <section className="intro__slide--start">
		<Header animatedLogo className="fixed top-0" />
		<div className="overflow-y-auto overflow-x-hidden w-screen mt-4 pt-12 px-4">
			<div className="bg-white bg-opacity-10 rounded-3xl py-8 m-auto max-w-4xl">
				<Hints />
				<H2 className="py-6 text-center">
					Welkom bij de<br />Klokhuis Scanner!
				</H2>
				{isBrowserSupported ?
					<PrimaryButton
						className="mb-4"
						onClick={() => {
							onNextSlideRequested('start');
							tag.sendClick('intro', {
								chapter3: 'start',
								name: 'next-slide',
							});
						}}>
						<Forward />
					</PrimaryButton> : <p className="mx-4 p-4 text-center rounded-lg bg-primary-800">
						Open je <span className="text-primary">Chrome</span> of <span className="text-primary">Safari</span> app om de Klokhuis Scanner te proberen!
					</p>}
			</div>
			{hasUserAction('intro:start:next-slide') &&
				<FeedbackButton className="w-full mt-4" />}
			<img src="/klokhuisscanner/pictures/illustrations/intro.jpg" className="m-auto" alt="Uitleg" />
		</div>
	</section>
}

Start.propTypes = {
	onNextSlideRequested: PropTypes.func.isRequired
}

export default Start
